<template>
  <div class="full-wrap">
    <div class="form">
      <div class="logo-wrap text-center">
        <router-link to="/">
          <img class="icon-logo" src="https://s1.huishoubao.com/static/pc/1001/img/logo.png">
        </router-link>
      </div>
      <div class="form-inner">
        <ul>
          <li class="clearfix">
            <Input v-model="loginTel" placeholder="请输入手机号码"/>
          </li>
          <li class="clearfix">
            <Input
              class="smscode-control fl"
              :class="{'is-counting': isCounting}"
              v-model="loginSmsCode"
              placeholder="请输入验证码"/>
            <Button class="button--smscode fr" :disabled="isGetSmsCodeButtonDisabled" @click="doGetCode">
              <template v-if="isCounting">{{ count }}s后重新获取</template>
              <template v-else>获取验证码</template>
            </Button>
          </li>
          <li class="clearfix">
            <hCheckBox class="col-expires" v-model="isLoginExpiresChecked">15天免登陆</hCheckBox>
            <hButton
              class="button--submit"
              size="large"
              type="primary"
              :disabled="isSubmitLoginDisabled"
              @click="doLogin"
            >登录</hButton>
          </li>
        </ul>
        <p class="login-tip">
          <img src="../../assets/login/login_icon_tips@2x.png">
          <span>若未注册回收宝账号，将自动注册回收宝账号</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import LoginMixin from '@/core/login/hsbLogin';
import { Button, Select, Input } from 'element-ui';
import HButton from '@/components/button';

export default {
  asyncData ({ store, route }) {
    return {};
  },
  data () {
    return {
    };
  },
  mounted () {
  },
  mixins: [LoginMixin],
  components: {
    Input,
    Button,
    Select,
    LoginMixin,
    HButton
  }
};
</script>
<style lang="postcss" scoped>

.full-wrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: url(https://www.huishoubao.com/static/pc/1001/img/banner-login.jpg) no-repeat center bottom;
}

.icon-logo {
  width: 250px;
  margin: 0 auto;
  padding-top: 50px;
}

.form {
  width: 800px;
  height: 550px;
  margin: 0 auto;
  margin-top: 8%;
  text-align: center;
  background-color: #fff;
  &-inner {
    width: 390px;
    margin: 0 auto;
    margin-top: 70px;
    text-align: left;
  }
  li {
    margin-bottom: 20px;
  }
  /deep/ .el-input__inner {
    height: 48px;
    line-height: 48px;
    border-radius: 2px;
  }
}

.smscode-control {
  width: 280px;
  &.is-counting {
    width: 258px;
  }
}

.button--smscode {
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 16px;
  padding-bottom: 16px;
  border-radius: 2px;
  border: 0;
  font-size: 16px;
  color: #409eff;
  &[disabled] {
    color: #c0c4cc;
  }
}

.button--submit {
  width: 100%;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  margin-top: 20px;
  /deep/ .hsb-button-text {
    vertical-align: baseline;
  }
}

.login-tip {
  margin-top: 42px;
  text-align: center;
  img {
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/login/index.vue